import React from "react";
import {FormattedMessage} from "react-intl";
import classes from "./styles.module.css";

const EmptyChart = () => {
    return (
        <div className={classes.EmptyChart}>
            <span>
                <FormattedMessage id="EmptyChart.message" defaultMessage="Недостаточно данных для построения графика"/>
            </span>
        </div>
    );
};

export default EmptyChart;



// WEBPACK FOOTER //
// ./src/Components/Charts/EmptyChart.js